// extracted by mini-css-extract-plugin
export default {"cls1":"Allocation-AllocationTypeIcon_cls1__Pw-Wu","cls2":"Allocation-AllocationTypeIcon_cls2__Qh51T Allocation-AllocationTypeIcon_cls1__Pw-Wu"};